module.exports = __webpack_public_path__ + "static/montserrat-bold-webfont-469cf77fb1dbbbc60192082f37f70b5a.woff";